import React, { Fragment } from 'react';
import Operations from "./operations";
import { SdfIcon, SdfSpotIllustration } from '@synerg/react-components';

export default function GroupedDomainSubCategoriesView({ groupedResults, showEventSubscriptions, productCode, ...rest}) {

	return (
		<>
			{groupedResults && groupedResults.length > 0 ?
				groupedResults.map((section) => {
					const header = section.header ? section.header.split(';') : [];
					const items = section.list || [];
					return (
						<div key={header}>
							<div className='flex my-4 items-baseline'>
								<div className='text-heading-03'>{header.length ? `${header[0]}` : ''}</div>
								<SdfIcon
								role="presentation"
								className="cursor-pointer no-underline hover:no-underline"
								icon="nav-page-next"
								/>
								<div className='text-body-03'>{header.length ? `${header[1]}` : ''}</div>
							</div>
							<Operations {...{ showEventSubscriptions, header, items, productCode, ...rest }} />
						</div>
					);
				}) :
				<div style={{ height: '23rem' }} className="flex flex-col items-center align-items justify-center">
					<SdfSpotIllustration illustrationName="empty-skills" size="md" />
					<div className="mt-10 text-center">
						<div
						className="text-2xl font-bold leading-xs tracking-xs text-heading-04 text-tertiary"
						>
							No results found
						</div>
					</div>
				</div>
			}
		</>
	);
}
